import './style.css';
import 'ol-layerswitcher/dist/ol-layerswitcher.css';


import Point from 'ol/geom/Point.js';
import Feature from 'ol/Feature.js';
import GPX from 'ol/format/GPX.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import VectorSource from 'ol/source/Vector.js';
import { Map, View } from 'ol';
import Overlay from 'ol/Overlay.js';
import { Circle as CircleStyle, Fill, Stroke, Style, Icon, Text } from 'ol/style.js';
import { Group as LayerGroup, Tile as TileLayer, Vector as VectorLayer } from 'ol/layer.js';
import OSM from 'ol/source/OSM';
import { transform, toLonLat, fromLonLat, get as getProjection } from 'ol/proj.js';
import { ScaleLine, FullScreen, defaults as defaultControls } from 'ol/control.js';
import XYZ from 'ol/source/XYZ';
import WMTS from 'ol/source/WMTS.js';
import WMTSTileGrid from 'ol/tilegrid/WMTS.js';
import { getWidth } from 'ol/extent.js';
import LayerSwitcher from 'ol-layerswitcher';
//import { BaseLayerOptions, GroupLayerOptions } from 'ol-layerswitcher';
//import decode from 'html-entities-decoder';


const style = {
  'Point': new Style({
    image: new CircleStyle({
      fill: new Fill({
        color: 'rgba(255,255,0,0.4)',
      }),
      radius: 5,
      stroke: new Stroke({
        color: '#ff0',
        width: 1,
      }),
    }),
  }),
  'LineString': new Style({
    stroke: new Stroke({
      color: '#f00',
      width: 3,
    }),
  }),
  'MultiLineString': new Style({
    stroke: new Stroke({
      color: '#0f0',
      width: 3,
    }),
  }),
};


const osm = new TileLayer({
  title: 'OSM',
  type: 'base',
  visible: true,
  source: new OSM()
})

const resolutions = [];
const matrixIds = [];
const projGeop = getProjection('EPSG:3857');
const WGS84 = getProjection('EPSG:4326');
const maxResolution = getWidth(projGeop.getExtent()) / 256;

for (let i = 0; i < 20; i++) {
  matrixIds[i] = i.toString();
  resolutions[i] = maxResolution / Math.pow(2, i);
}

const tileGrid = new WMTSTileGrid({
  origin: [-20037508, 20037508],
  resolutions: resolutions,
  matrixIds: matrixIds,
});

const ign_source = new WMTS({
  url: "https://data.geopf.fr/wmts",
  layer: 'GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2',
  matrixSet: 'PM',
  format: 'image/png',
  projection: projGeop,
  tileGrid: tileGrid,
  style: 'normal',

  attributions:
    '<a href="https://www.ign.fr/" target="_blank">© IGN</a>',
});

const ign = new TileLayer({
  source: ign_source,
  title: 'IGN',
  type: 'base',
  //visible: false,
});

const ignSat_source = new WMTS({
  url: "https://data.geopf.fr/wmts",
  layer: 'ORTHOIMAGERY.ORTHOPHOTOS',
  matrixSet: 'PM',
  format: 'image/jpeg',
  projection: projGeop,
  tileGrid: tileGrid,
  style: 'normal',
  attributions:
    '<a href="https://www.ign.fr/" target="_blank">© IGN</a>',
});

const ignSat = new TileLayer({
  source: ignSat_source,
  title: 'IGN Sat',
  type: 'base',
  //visible: false,
});


const baladeFunction = function (feature, resolution) {
  return stylesBalade[feature.get('pratique')];
};

const traceFunction = function (feature, resolution) {
  // Lines
  if (feature.getGeometry().getType() != 'Point') {
    var styles = [];
    styles.push(new Style({
      stroke: new Stroke({
        color: '#ffffff',
        width: 6,
      }),
      text: createTextStyle(feature, resolution),
    }));
    styles.push(new Style({
      stroke: new Stroke({
        color: '#aa3300',
        width: 2,
      })
    }));
    return (styles);
  }
  // Point avec sym direct comme Bipedum ou juste
  else {
    var sym = typeof feature.get('sym') !== typeof undefined ? true : false;
    var hebRa = typeof feature.get('link') !== typeof undefined ? true : false;
    if (sym) {
      if (feature.get('sym').indexOf("https://") == -1) var icon = '/image_2012/slider/' + feature.get('sym').toLowerCase() + '.png';
      else var icon = feature.get('sym');
    }

    else if(hebRa) {//si lien
      if (feature.get('link').indexOf("rando-accueil") !== -1) var icon = '/carte/map/ra_yellow.png'; else var icon = '/carte/map/rouge.png';
    }
    else var icon = '/carte/map/rouge.png';
    
    return new Style({
      image: new Icon({
        anchor: [0.5, 1],
        src: icon
      })
    });
  }
};

const createTextStyle = function (feature, resolution) {
  const align = 'center';
  const baseline = 'middle';
  const size = '20px';
  const height = '1';
  const offsetX = 0;
  const offsetY = 0;
  const weight = 'normal';
  const placement = undefined;
  const maxAngle = undefined;
  const overflow = undefined;
  const rotation = 0;


  const font = weight + ' ' + size + '/' + height + ' Verdana ';
  const fillColor = '#aa3300';
  const outlineColor = '#ffffff';
  const outlineWidth = 3;

  return new Text({
    textAlign: align == '' ? undefined : align,
    textBaseline: baseline,
    font: font,
    text: getText(feature, resolution),
    fill: new Fill({ color: fillColor }),
    stroke: new Stroke({ color: outlineColor, width: outlineWidth }),
    offsetX: offsetX,
    offsetY: offsetY,
    placement: placement,
    maxAngle: maxAngle,
    overflow: overflow,
    rotation: rotation,
  });
};

const getText = function (feature, resolution) {
  const type = 'wrap';
  const maxResolution = '1200';
  let text = feature.get('name');
  var nameIs = typeof text !== typeof undefined ? true : false;

  if (resolution > maxResolution) {
    text = '';
  } else if ((type == 'shorten') && nameIs) {
    text = text.trunc(12);
  } else if ((type == 'wrap') && nameIs) {
    text = stringDivider(text, 16, '\n');
  } else {
    text = '';
  }

  return text;
};

/**
 * @param {number} n The max number of characters to keep.
 * @return {string} Truncated string.
 */
String.prototype.trunc =
  String.prototype.trunc ||
  function (n) {
    return this.length > n ? this.substr(0, n - 1) + '...' : this.substr(0);
  };

function stringDivider(str, width, spaceReplacer) {
  if (str.length > width) {
    let p = width;
    while (p > 0 && str[p] != ' ' && str[p] != '-') {
      p--;
    }
    if (p > 0) {
      let left;
      if (str.substring(p, p + 1) == '-') {
        left = str.substring(0, p + 1);
      } else {
        left = str.substring(0, p);
      }
      const right = str.substring(p + 1);
      return left + spaceReplacer + stringDivider(right, width, spaceReplacer);
    }
  }
  return str;
}


const image = new CircleStyle({
  radius: 5,
  fill: new Fill({
    color: 'rgba(255, 255, 0, 0.9)',
  }),
  stroke: new Stroke({ color: 'red', width: 1 }),
});


const stylesBalade = {
  'heb': new Style({
    image: new Icon({
      anchor: [0.5, 1],
      src: '/carte/map/ra_yellow.png',
    })
  }),
  '1': new Style({
    image: new Icon({
      anchor: [0.5, 0.5],
      src: '/image_2012/slider/Log1p.png',
    })
  }),
  '2': new Style({
    image: new Icon({
      anchor: [0.5, 0.5],
      src: '/image_2012/slider/Log2p.png',
    })
  }),
  '3': new Style({
    image: new Icon({
      anchor: [0.5, 0.5],
      src: '/image_2012/slider/Log3p.png',
    })
  }),
  '4': new Style({
    image: new Icon({
      anchor: [0.5, 0.5],
      src: '/image_2012/slider/Log4p.png',
    })
  }),
  '5': new Style({
    image: new Icon({
      anchor: [0.5, 0.5],
      src: '/image_2012/slider/Log5p.png',
    })
  }),
  '6': new Style({
    image: new Icon({
      anchor: [0.5, 0.5],
      src: '/image_2012/slider/Log6p.png',
    })
  }),
  'iti_1': new Style({
    image: new Icon({
      aanchor: [0.5, 0.5],
      src: '/image_2012/slider/iti_1.png',
    })
  }),
  'iti_2': new Style({
    image: new Icon({
      anchor: [0.5, 0.5],
      src: '/image_2012/slider/iti_2.png',
    })
  }),
  'iti_3': new Style({
    image: new Icon({
      anchor: [0.5, 0.5],
      src: '/image_2012/slider/iti_3.png',
    })
  })
}

const stylesTrace = {
  'Point': new Style({
    image: image,
  }),
  'LineString': new Style({
    stroke: new Stroke({
      color: 'green',
      width: 1,
    }),
  }),
  'MultiLineString': new Style({
    stroke: new Stroke({
      color: 'green',
      width: 1,
    }),
  }),
  'heb': new Style({
    image: new Icon({
      anchor: [0.5, 1],
      src: '/carte/map/ra_yellow.png',
    }),
  }),
  '1': new Style({
    image: new Icon({
      anchor: [0.5, 0.5],
      src: '/image_2012/slider/Log1p.png',
    }),
  }),
  '2': new Style({
    image: new Icon({
      anchor: [0.5, 0.5],
      src: '/image_2012/slider/Log2p.png',
    }),
  }),
  'Départ': new Style({
    image: new Icon({
      anchor: [0.5, 0.5],
      src: '/image_2012/slider/2.png',
    }),
  })
}



const balade = new VectorLayer({
  source: new VectorSource({
  }),
  style: baladeFunction,
  title: 'Mes circuits',
  visible: true,
  attributions: '© Rando Accueil'
});

const trace = new VectorLayer({
  source: new VectorSource({
  }),
  style: traceFunction,
  title: 'GPX',
  visible: false,
});

const cycling = new TileLayer({
  source: new XYZ({
    url: 'https://tile.waymarkedtrails.org/cycling/{z}/{x}/{y}.png',
    attributions: '<a href="https://cycling.waymarkedtrails.org/help/legal">© waymarkedtrails.org, CC by-SA 3.0</a>'
  }),
  opacity: 0.8,
  maxZoom: 18,
  title: 'Iti à Vélo',
  visible: false,
});


const hiking = new TileLayer({
  source: new XYZ({
    url: 'https://tile.waymarkedtrails.org/hiking/{z}/{x}/{y}.png',
    attributions: '<a href="https://hiking.waymarkedtrails.org/help/legal">© waymarkedtrails.org, CC by-SA 3.0</a>'
  }),
  opacity: 0.8,
  visible: true,
  maxZoom: 18,
  title: 'Iti à pied',
  visible: true,
});

const winter = new TileLayer({
  source: new XYZ({
    url: 'https://tile.waymarkedtrails.org/slopes/{z}/{x}/{y}.png',
    attributions: '<a href="https://slopes.waymarkedtrails.org/help/legal">© waymarkedtrails.org, CC by-SA 3.0</a>'
  }),
  opacity: 0.8,
  maxZoom: 18,
  title: 'Iti à Ski',
  visible: false,
});

const mtb = new TileLayer({
  source: new XYZ({
    url: 'https://tile.waymarkedtrails.org/mtb/{z}/{x}/{y}.png',
    attributions: '<a href="https://mtb.waymarkedtrails.org/help/legal">© waymarkedtrails.org, CC by-SA 3.0</a>'
  }),
  opacity: 0.8,
  maxZoom: 18,
  title: 'Iti à VTT',
  visible: false,
});


//utile ou pas ?

const groupBase = new LayerGroup({
  title: 'Carte',
  combine: false,
  layers: [ignSat, ign, osm]
});

if (uni_neig == 0) var list = [mtb, cycling, hiking, balade];
else var list = [winter, mtb, cycling, hiking, balade];
const groupRando = new LayerGroup({
  title: 'Rando',
  combine: false,
  layers: list
});


/**
 * Elements that make up the popup.
 */
const container = document.getElementById('popup');
const content = document.getElementById('popup-content');
const closer = document.getElementById('popup-closer');

/**
 * Create an overlay to anchor the popup to the map.
 */
const overlay = new Overlay({
  element: container,
  autoPan: {
    animation: {
      duration: 250,
    },
  },
  //valuer pour décaler le pop up issu des lien
  offset: [0, -25],
  positioning: 'bottom-center'
});

/**
 * Add a click handler to hide the popup.
 * @return {boolean} Don't follow the href.
 */
closer.onclick = function () {
  overlay.setPosition(undefined);
  closer.blur();
  return false;
};


const map = new Map({
  controls: defaultControls().extend([new FullScreen({ source: 'fullscreen' }), new ScaleLine({
    units: 'metric',
    //bar: true,
    //steps: parseInt(2, 10),
    //minWidth: 100,
    maxWidth: 150,
  })]),
  layers: [groupBase, groupRando, trace],
  overlays: [overlay],
  target: 'map',
  view: new View({
    center: fromLonLat([heb_lon, heb_lat]),
    zoom: 12,
    maxZoom: 17,
    projection: projGeop
  })
});

var layerSwitcher = new LayerSwitcher({
  //reverse: true,
  //activationMode: 'click',
  startActive: true,
  tipLabel: 'Layers', // Optional label for button
  groupSelectStyle: 'none'
});
map.addControl(layerSwitcher);


const decodeur = function (text) {
  var map = {
    '&amp;': '&',
    '&#038;': "&",
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#039;': "'",
    '&#8217;': "’",
    '&#8216;': "‘",
    '&#8211;': "–",
    '&#8212;': "—",
    '&#8230;': "…",
    '&#8221;': '”'
  };

  return text.replace(/\&[\w\d\#]{2,5}\;/g, function (m) { return map[m]; });
};

const displayFeatureInfo = function (evt) {
  balade.getFeatures(evt.pixel).then(function (features) {
    const feature = features.length ? features[0] : undefined;
    const coordinate = toLonLat(evt.coordinate);
    if ((features.length) && (balade.getVisible())) {
      //heb
      if (feature.get('pratique') == 'heb') {
        content.innerHTML = feature.get('html');
        overlay.setPosition(fromLonLat(coordinate));
      }
      //Rando ou activité
      else if (feature.get('pratique').length >= 1) {
        {
          console.log('Rando feature');
          content.innerHTML = PopUp(feature);
          overlay.setPosition(fromLonLat(coordinate));
        }
      }
    }//fin if feature.lenght
    //si pas de feature sur balade chercher sur trace
    else {
      trace.getFeatures(evt.pixel).then(function (features) {
        const feature = features.length ? features[0] : undefined;
        const coordinate = toLonLat(evt.coordinate);
        if ((features.length) && (trace.getVisible())) {//trace
          console.log('trace feature');
          var html = '<div id="inner"><span class=NomBleu>' + feature.get('name') + '</span><b><br />';
          if (typeof feature.get('desc') !== 'undefined') html += feature.get('desc');
          if (feature.get('link'))
            html += '  <a href="' + feature.get('link') + '" target="_blank" >Lien</a>';
          html += '</div>';
          content.innerHTML = html;
          overlay.setPosition(fromLonLat(coordinate));
        }
        else //iti
        {
          console.log('Iti feature');
          fetch(query([coordinate[1], coordinate[0]], map.getView().getZoom()))
            .then(response => response.json())
            .then(response => traiterReponse(response))
            .then(response => { content.innerHTML = response; overlay.setPosition(fromLonLat(coordinate)); })
            .catch(error => console.log("Erreur : " + error));
          //document.getElementById('info').innerHTML = map.getView().getZoom() + "resolution" + map.getView().getResolutions();
        }
      })
    } //fin else pas balade

  });
};

const PopUp = function (feature) {

  var html = '<div id="inner"><span class=NomBleu>' + feature.get('name') + '</span><b><br /><span class="ui-icon ui-icon-arrow-2-e-w"></span>' + feature.get('km') + ' km   <span class="ui-icon ui-icon-clock"></span>' + feature.get('tps');
  if ((feature.get('deniv') != 0) && (feature.get('deniv') != null)) { html += '   <span class="ui-icon ui-icon-arrow-1-ne"></span>' + feature.get('deniv') + 'm'; }
  html += '</b><br />' + decodeur(feature.get('texte')) + '<br />';
  //Gpx affichage lien externe
  if ((feature.get('gpx').indexOf("https://") != -1) || (feature.get('gpx').indexOf("http://") != -1))
    html += '<a href=javascript:void(0); onclick="loadGpx(\'' + feature.get('gpx') + '\', \'' + feature.get('pratique') + '\'); "><span class="ui-icon ui-icon-circle-check"></span>Afficher LE GPX</a>   <a href="' + feature.get('gpx') + '" target="_blank"><span class="ui-icon ui-icon-arrowthickstop-1-s"></span>GPX</a>'
  //Gpx affichage lien interne
  else if (feature.get('gpx').length >= 3) {
    if(feature.get('gpx').indexOf("/") != -1) var heb_lien = ''; else heb_lien=plus['heb_id'] + '/';
    html += '    <a href=javascript:void(0); onclick="loadGpx(\'/gpx/' + heb_lien + feature.get('gpx') + '.gpx\', \'' + feature.get('pratique') + '\'); "><span class="ui-icon ui-icon-circle-check"></span>Afficher GPX</a>   <a href="/gpx/' + heb_lien + feature.get('gpx') + '.gpx" "target="_blank"><span class="ui-icon ui-icon-arrowthickstop-1-s"></span>GPX  </a>';
    //GPX affichage lien interne pour rando si GPX
    html += '<span class="ui-icon ui-icon-extlink"></span><a href="/randonnee/Balade-Rando-Accueil-' + feature.getId() + '.htm" target="_blank">En savoir +</a>';
  }
  //GPX affichage lien externe
  if ((feature.get('lien').indexOf("https://") != -1) || (feature.get('lien').indexOf("http://") != -1))
    html += '    <a href="' + feature.get('lien') + '" target="_blank"><span class="ui-icon ui-icon-extlink"></span>Lien externe</a>';
  //GPX affichage lien interne pour pave
  else if (feature.get('lien') == 'pave')
    html += '   </span><span class="ui-icon ui-icon-extlink"></span><a href="/activites/sejour-rando-accueil-' + feature.getId() + '.htm" target="_blank">En savoir +</a>';

  html += '</div>';

  return html;
}



const traiterReponse = function (data) {
  var i, relation;
  var route_id, route_name, route_desc, route_ref;

  var html = "";
  var ul, li, img, txt, div;

  var baseUrl, baseSymbol, baseRoute;

  ul = document.createElement('ul');
  ul.className = "leaflet-trails";

  for (i = 0; i < data.elements.length; i++) {
    relation = data.elements[i];
    route_id = relation.id;
    //voir from to ?
    route_name = relation.tags.name ? relation.tags.name : route_id;
    route_desc = relation.tags.description ? relation.tags.description : false;
    route_ref = relation.tags.ref ? relation.tags.ref : false;

    route_name = (route_name == route_id && route_desc) ? route_desc : route_name;
    route_name = (route_name == route_id && route_ref) ? "relation " + route_ref : route_name;

    txt = document.createTextNode(route_name);

    img = document.createElement('img');

    switch (relation.tags.route) {
      case 'bicycle':
        img.src = '/image_2012/slider/Log2p.png';
        break;
      case 'hiking':
        img.src = '/image_2012/slider/Log1p.png';
        break;
      case 'piste':
        img.src = '/image_2012/slider/Log5p.png';
        break;
      case 'horse':
        img.src = '/image_2012/slider/Log4p.png';
        break;
      case 'mtb':
        img.src = '/image_2012/slider/Log3p.png';
        break;
      default:
        img.src = false;
        break;
    }

    if (img.src !== false) {
      li = document.createElement('li');
      div = document.createElement('div');
      div.appendChild(img);
      li.appendChild(div);
      div = document.createElement('div');
      div.appendChild(txt);
      li.appendChild(div);
      ul.appendChild(li);
    }

  }

  if (ul.children.length == 0) {
    //return false;
    throw new Error('Pas d\'itinéraires enregistré')
  }

  html += ul.outerHTML;
  return html;
}

const query = function (coords, zoom) {
  let radius = 5000;
  if (zoom >= 17) radius = 5;
  else if (zoom >= 15) radius = 10;
  else if (zoom >= 12) radius = 50;
  else if (zoom <= 8) radius = 5000;
  else radius = 100;

  let type = "^" + "bicycle" + "$";

  let requete = '[out:json];(relation["route"~"^hiking$|^bicycle$|^slopes$|^riding$|^mtb$|^piste$"](around:' + radius + ',' + coords[0] + ',' + coords[1] + '););out;>;';

  let url = 'https://overpass-api.de/api/interpreter?data=' + encodeURIComponent(requete) + '&callback=?';

  return url;

}

map.on('click', function (evt) {
  displayFeatureInfo(evt);
});

// charge les points balade
const loadJson = function (url) {
  fetch(url)
    .then(response => response.json())
    .then(json => {
      if (json.features.length != 0) {//si le json contient des circuits
        //Ajout au calques
        balade.getSource().addFeatures(
          new GeoJSON().readFeatures(json, {
            dataProjection: WGS84,
            featureProjection: projGeop
          })
        );
        //Ajout legende
        for (const circuit of json.features) {
          const Item = document.createElement("div");
          Item.className = "Item";
          Item.classList.add("Item" + circuit.properties.pratique);
          Item.classList.add("ui-button");
          Item.classList.add("ui-corner-all");
          const strong = document.createElement("strong");
          strong.textContent = circuit.properties.name;
          Item.appendChild(strong);
          /* const span = document.createElement("span");
          span.className = "ui-icon ui-icon-info";
          strong.append(span); */
          document.getElementById("detail_map").appendChild(Item);
          (function (listItem, id) {
            showPopup(listItem, id);
          })(Item, circuit.id);//fin closure	


        }
      }
      else loadHeb();
    })
    .then(function () { loadHeb(); doBounceExtent(balade.getSource().getExtent()); })
    .catch(error => console.log("Erreur : " + error));
}
// Simulation click sur point de la map
function showPopup(listItem, id) {
  listItem.onclick = function () {
    var feature = balade.getSource().getFeatureById(id);
    if (feature.get('pratique').length >= 1) {

      content.innerHTML = PopUp(feature);
      trace.setVisible(false);
      balade.setVisible(true);
      overlay.setPosition(feature.getGeometry().getCoordinates());
    };

  }
}

//charge les trace balade + ititi
const loadGpx = function (url, prat) {
  fetch(url)
    .then(response => response.text())
    .then(text => {
      trace.getSource().clear();
      trace.getSource().addFeatures(
        new GPX().readFeatures(text, {
          dataProjection: WGS84,
          featureProjection: projGeop
        })
      )
    })
    .then(function () {
      layerSwitcher.renderPanel(); balade.setVisible(false); cycling.setVisible(false); hiking.setVisible(false); winter.setVisible(false); mtb.setVisible(false); doBounceExtent(trace.getSource().getExtent()); overlay.setPosition(undefined); closer.blur(); //groupRando.push(trace); 
      groupRando.setZIndex(99);
      if (prat == '1' || prat == 'iti_1') hiking.setVisible(true);
      if (prat == '2' || prat == 'iti_2') cycling.setVisible(true);
      if (prat == '3' || prat == 'iti_3') mtb.setVisible(true);
      trace.setZIndex(100);
      trace.setVisible(true);
      //map.addLayer(trace);
    })
    .catch(error => console.log("Erreur : " + error));
}
//Rend accessible la fonction
window.loadGpx = loadGpx;

//loadGpx('1579.gpx');

const doBounceExtent = function (extent) {
  map.getView().fit(extent, { padding: [75, 75, 75, 75], duration: 1000 });
  console.log('zoom');
}
//-----------Ajout des points------------

loadJson(url);

const loadHeb = function () {
  var html = "<div id='inner'><span class='NomBleu'>" + HEB_NOM + "</span><b><br />" + heb_type + "</b><br /><br />" + HEB_PROPRIO + "</div>";
  var heb = new Feature({
    geometry: new Point(transform([parseFloat(heb_lon), parseFloat(heb_lat)], WGS84, projGeop)), html: html, pratique: 'heb'
  });
  balade.getSource().addFeature(heb);
}
